const asArray = (item) => (Array.isArray(item) ? item : [item]);

const getStringDefaultValueIfEmpty = (originalValue) => originalValue || '';

const getObjectDefaultValueIfEmpty = (originalValue) => originalValue || {};

const getPristineImagePath = (product) =>
  product.pristineImages ? product.pristineImages.pristine1ImagePath : '';

const getImagePath = (product) =>
  product.categoryLargeImage || product.quicklookImage || {};

const IsOutOfStock = (product) => product.inventoryStatusId === '3';

const prepareDropshipData = (product) => {
  if (product?.webProductType === 'Dropship') {
    const {
      isExcludedFromPromotion,
      isShowSellerName,
      isFreeShipping,
      isLowestPriceCC,
      vendorName,
    } = product;
    return {
      dropshipData: {
        isExcludedFromPromotion,
        isShowSellerName,
        isFreeShipping,
        isLowestPriceCC,
        vendorName,
      },
    };
  }
};

const getChildProducts = (category) => {
  if (!category.childProducts) return [];

  return asArray(category.childProducts).map((product) => {
    const imagePath = getImagePath(product).path;
    const { avImages } = product;
    const { marketingFlagName } = getObjectDefaultValueIfEmpty(
      product.marketingFlag
    );
    const pristineImagePath = getPristineImagePath(product);

    return {
      additionalQueryParams: getStringDefaultValueIfEmpty(
        product.additionalQueryParams
      ),
      altText: product.altText || getStringDefaultValueIfEmpty(product.name),
      avImages: getObjectDefaultValueIfEmpty(avImages),
      marketingFlag: {
        marketingFlagName,
      },
      name: getStringDefaultValueIfEmpty(product.name),
      outOfStock: IsOutOfStock(product),
      price: getObjectDefaultValueIfEmpty(product.price),
      pristineImageUrl: pristineImagePath,
      productID: product.businessCatalogItemId,
      productURL: getStringDefaultValueIfEmpty(product.productURL),
      reviewCount: product.reviewCount,
      reviewScore: product.reviewScore,
      swatchesProps: getObjectDefaultValueIfEmpty(product.swatchesProps),
      url: product.url || imagePath,
      vid: product.defaultSizeVariantId,
      zoomImages: getObjectDefaultValueIfEmpty(product.zoomImages),
      ...prepareDropshipData(product),
    };
  });
};

const composeCategory = (category) => {
  const products = getChildProducts(category);

  if (products.length === 0) return null;

  return {
    heading: getStringDefaultValueIfEmpty(category.name),
    cid:
      category.businessCatalogItemId ||
      getStringDefaultValueIfEmpty(category.id),
    products,
  };
};

const adapter = (response) => {
  const category = response.productCategoryFacetedSearch.productCategory;
  const categories = asArray(category.childCategories ?? category);

  return categories.map(composeCategory).filter(Boolean);
};

export default adapter;
